module.exports = __webpack_public_path__ + "img/tj.86376d65.png";